export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lists-list.vue?vue&type=template&id=c8fac292&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/games/lists-list.vue?vue&type=template&id=c8fac292&scoped=true
// module id = 9pMn
// module chunks = 0